import { RouteObject } from "react-router-dom";
import { TopBarPageContainer } from "../../components/PageContainer";
import { Button } from "@narmi/design_system";

export const RISK_MANAGER_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { RiskManager } = await import("./RiskManager");
      return {
        element: (
          <TopBarPageContainer
            title="Risk manager"
            action={
              <Button
                size="xs"
                label="Add rule"
                onClick={() => (window.location.href = "/rules")}
              />
            }
          >
            <RiskManager />
          </TopBarPageContainer>
        ),
      };
    },
  },
];
